import React from "react";

/**
 * Finhabits brand mark — Variant C (moss green soft-fill triangle with hashtag).
 *
 * Props:
 *   size: number (px). Defaults to 32. Render at 20 for favicon, 32 for nav, 48+ for hero.
 *   className: optional extra classes on the wrapper <svg>.
 *
 * The mark is self-contained — it doesn't need a colored background container.
 */
export default function Logo({ size = 32, className = "" }) {
  // Stroke width is tuned for legibility at each size bracket.
  const strokeWidth = size <= 24 ? 3 : size <= 40 ? 2.6 : 2.4;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Finhabits logo"
      role="img"
    >
      <path d="M28 6 L52 48 L4 48 Z" fill="#607762" />
      <g
        stroke="#FBF6EC"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      >
        <line x1="22" y1="30" x2="22" y2="44" />
        <line x1="30" y1="28" x2="30" y2="44" />
        <line x1="17.5" y1="34" x2="34" y2="34" />
        <line x1="17.5" y1="40" x2="34" y2="40" />
      </g>
    </svg>
  );
}
